export default "__VITE_ASSET__rTf9gEOO__"